export default __webpack_public_path__ + "static/office-meeting-b0df083c355ce87b1f5241587d0f08ab.jpg";